export default __webpack_public_path__ + "static/fur-hero-desktop-f9fe824bbcbfbab7afc723865693c7eb.png";